import { Typography } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import axios from "axios";
import { useState } from "react";
import { Fragment } from "react/jsx-runtime";
import { InputFileUploadCSV } from "../../utils/InputFileUploadCSV";

interface Props {
  open: boolean;
  handleCloseModal: (a: boolean) => void;
}

export const FormDialog: React.FC<Props> = ({ open, handleCloseModal }) => {
  const [fileData, setFileData] = useState<File>();
  const [fileSize, setFileSize] = useState("");

  const handleClose = () => {
    handleCloseModal(false);
  };

  const handleFileLoad = (file: File) => {
    console.log(file);
    setFileData(file);
    setFileSize(formatFileSize(file.size));
  };

  const handleProcess = async () => {
    console.log("procesar solicitud", fileData);
    if (fileData) {
      await uploadFile(fileData);
    }
  };

  const uploadFile = async (file: File) => {
    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await axios.post(
        "http://localhost:8080/api/fileupload",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      console.log("Archivo cargado con éxito:", response.data);
    } catch (error) {
      console.error("Error al cargar el archivo:", error);
    }
  };

  const formatFileSize = (sizeInBytes: number): string => {
    const sizeInKB = sizeInBytes / 1024;
    if (sizeInKB < 1024) {
      // Si el tamaño es menor a 1024 KB, muestra en KB
      return `${sizeInKB.toFixed(2)} KB`;
    } else {
      // Si el tamaño es mayor o igual a 1024 KB, muestra en MB
      const sizeInMB = sizeInKB / 1024;
      return `${sizeInMB.toFixed(2)} MB`;
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        component: "form",
        onSubmit: (event: React.FormEvent<HTMLFormElement>) => {
          event.preventDefault();
          const formData = new FormData(event.currentTarget);
          const formJson = Object.fromEntries((formData as any).entries());
          const email = formJson.email;
          console.log(email);
          handleClose();
        },
      }}
    >
      <DialogTitle>Carga un archivo en .csv</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Puedes cargar unicamente archivos en formato .scv separado por comas.
          Descarga un ejemplo del formato aquí.
        </DialogContentText>
        <br />
        <InputFileUploadCSV onFileUpload={handleFileLoad} />
        <br />
        <br />
      </DialogContent>
      <DialogActions>
        {fileData && (
          <Typography variant="caption" sx={{ textAlign: "left" }}>
            {fileData?.name} - {fileSize}
          </Typography>
        )}
        <Button onClick={handleClose}>Cancel</Button>
        <Button onClick={handleProcess}>Procesar</Button>
      </DialogActions>
    </Dialog>
  );
};
